import { render, staticRenderFns } from "./Qian10daSection.vue?vue&type=template&id=929fd442&scoped=true&"
import script from "./Qian10daSection.vue?vue&type=script&lang=js&"
export * from "./Qian10daSection.vue?vue&type=script&lang=js&"
import style0 from "./Qian10daSection.vue?vue&type=style&index=0&id=929fd442&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "929fd442",
  null
  
)

export default component.exports